import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_QUICKBOOKS = `${ACCOUNT_SERVICE}/quickbooks`;

export const quickBooks = {
  getImports: async () => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS}/imports`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
